import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import UpdateBloc from "./Blocs/UpdateBloc";
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";
import { accessRole } from "../../../../helpers/access_role";

var reformatOptionRank = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.rank_name;
    newObj["value"] = region.rank_uuid;
    return newObj;
  });
};

var reformatSignatory = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] =
      region.signatories_official_nip +
      " - " +
      region.signatories_official_name;
    newObj["value"] = region.signatories_official_uuid;
    newObj["nip_pejabat"] = region.signatories_official_nip;
    newObj["nama_pejabat"] = region.signatories_official_name;
    return newObj;
  });
};

var reformatOptionDocument = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.document_type_name;
    newObj["value"] = region.document_type_uuid;
    return newObj;
  });
};

class IndexView extends Component {
  updateBloc = new UpdateBloc();

  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_uuid
    : "";

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        sumpahSelected: "",
      },
      nip_pejabat: "",
      nama_pejabat: "",
      rankItems: [],
      rankSelected: "",
      sigantoryItems: [],
      sigantorySelected: "",
      documentTypeItems: [],
      documentTypeSelected: "",
    };
  }

  submitData = async () => {
    if (this.state.dataForm.document.length > 0) {
      let formData = generateFormData(this.state.dataForm, "document");
      await this.updateBloc.fetchUpdate(formData);
    } else {
      await this.updateBloc.fetchUpdate(this.state.dataForm);
    }
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        employee_uuid: this.peg_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  onChangeSumpah = (event) => {
    const target = event.target;
    const value = target.checked ? 1 : 0;
    this.setState({
      dataForm: {
        sumpahSelected: value,
      },
    });
  };

  onchangeRank = (rankSelected) => {
    this.setState({
      rankSelected: rankSelected.value,
    });
  };

  onChangeSignatory = (signatory) => {
    this.setState({
      sigantorySelected: signatory.value,
      nip_pejabat: signatory.nip_pejabat,
      nama_pejabat: signatory.nama_pejabat,
    });
  };

  onChangeDcoumentType = (documentTypeSelected) => {
    this.setState({
      documentTypeSelected: documentTypeSelected.value,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.updateBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            debugger;
            // load to form
            this.setState({
              dataForm: {
                uuid: response.decree_p3k_uuid,
                employee_uuid: response.decree_p3k_employee_uuid,
                no_diklat: response.decree_p3k_training_number,
                no_sk: response.decree_p3k_decree_number,
                no_surat_kesehatan: response.decree_p3k_health_test_number,
                tanggal_diklat: response.decree_p3k_training_date,
                tanggal_kesehatan: response.decree_p3k_health_test_date,
                tanggal_sk: response.decree_p3k_decree_date,
                tanggal_tmt_sk: response.decree_p3k_decree_tmt,
                documents_path: response.documents_path,
                decree_p3k_status: response.decree_p3k_status,
                decree_p3k_status_description:
                  response.decree_p3k_status_description,
              },
              document: response.document,
              nip_pejabat: response.decree_p3k_signatories_official_nip,
              nama_pejabat: response.decree_p3k_signatories_official_name,
              rankSelected: response.decree_p3k_rank_uuid,
              sigantorySelected: response.decree_p3k_signatories_official,
              documentTypeSelected: response.decree_p3k_document_uuid,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.rankChanel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              rankItems: reformatOptionRank(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.signatoryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              sigantoryItems: reformatSignatory(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.documentTypeChanel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              documentTypeItems: reformatOptionDocument(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    const search = window.location.search;
    const queryParams = new URLSearchParams(search);
    this.updateBloc.fetchDetail({ uuid: queryParams.get("uuid") });

    this.updateBloc.fetchRank();
    this.updateBloc.fetchSignatory();
    this.updateBloc.fetchDocumentType();

    this.setState({
      dataForm: {
        sumpahSelected: 0,
      },
    });
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <PegawaiSideBar active="skp3k" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <CardTitle>Edit SK PPPK</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />

                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <AvField
                      name="uuid"
                      type="hidden"
                      id="uuid"
                      value={this.state.dataForm.uuid}
                    />
                    <AvField
                      name="employee_uuid"
                      type="hidden"
                      id="employee_uuid"
                      value={this.state.dataForm.employee_uuid}
                    />

                    {this.state.dataForm?.decree_p3k_status == 2 ? (
                      <Row className="mb-3">
                        <Col md="12">
                          <div
                            class="alert-dismissible fade show alert alert-danger alert-dismissible fade show"
                            role="alert"
                          >
                            <button
                              type="button"
                              class="close"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">×</span>
                            </button>
                            <i class="uil uil-exclamation-octagon me-2"></i>{" "}
                            Catatan Approval :{" "}
                            {this.state.dataForm?.decree_p3k_status_description}
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Pejabat Penetap <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <Select
                          value={this.state.sigantoryItems.filter(
                            (option) =>
                              option.value === this.state.sigantorySelected
                          )}
                          onChange={this.onChangeSignatory}
                          required="required"
                          options={this.state.sigantoryItems}
                          classNamePrefix=""
                        />
                        <AvField
                          name="sigantory_id"
                          type="hidden"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="sigantory_id"
                          value={this.state.sigantorySelected}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nama Pejabat Penetap{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="nama_pejabat"
                          id="nama_pejabat"
                          placeholder="Nama Pejabatan Penetap"
                          type="text"
                          className="form-control"
                          readOnly
                          value={this.state.nama_pejabat}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        NIP Pejabat Penetap{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="nip_pejabat"
                          id="nip_pejabat"
                          placeholder="NIP Pejabatan Penetap"
                          type="text"
                          className="form-control"
                          readOnly
                          value={this.state.nip_pejabat}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        No Surat Keputusan{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="no_sk"
                          id="no_sk"
                          placeholder="Nomor Surat Keputusan..."
                          type="text"
                          errorMessage="Nomor Surat Keputusan"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.dataForm.no_sk}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal Surat Keputusan{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="tanggal_sk"
                          placeholder="Tanggal SK..."
                          type="date"
                          errorMessage="Masukkan Tanggal SK"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="tanggal_sk"
                          value={this.state.dataForm.tanggal_sk}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Terhitung Mulai Tanggal{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="tanggal_tmt_sk"
                          placeholder="Terhitung Mulai Tanggal..."
                          type="date"
                          errorMessage="Masukkan Terhitung Mulai Tanggal"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="tanggal_tmt_sk"
                          value={this.state.dataForm.tanggal_tmt_sk}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        No Diklat Prajabatan{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="no_diklat"
                          id="no_diklat"
                          placeholder="Nomor Diklat..."
                          type="text"
                          errorMessage="Masukkan Nomor Diklat"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.dataForm.no_diklat}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal Diklat Prajabatan{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="tanggal_diklat"
                          placeholder="Tanggal Diklat..."
                          type="date"
                          errorMessage="Masukkan Tanggal Diklat"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="tanggal_diklat"
                          value={this.state.dataForm.tanggal_diklat}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        No Surat Uji Kesehatan{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="no_surat_kesehatan"
                          id="no_surat_kesehatan"
                          placeholder="Masukan No Surat Uji Kesehatan..."
                          type="text"
                          errorMessage="Masukkan Nomor Surat Uji Kesehatan"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.dataForm.no_surat_kesehatan}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal Surat Uji Kesehatan{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="tanggal_kesehatan"
                          placeholder="Tanggal Surat Uji Kesehatan..."
                          type="date"
                          errorMessage="Masukkan Tanggal Surat Uji Kesehatan"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="tanggal_kesehatan"
                          value={this.state.dataForm.tanggal_kesehatan}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Golongan Ruang <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <Select
                          value={this.state.rankItems.filter(
                            (option) => option.value === this.state.rankSelected
                          )}
                          onChange={this.onchangeRank}
                          required="required"
                          options={this.state.rankItems}
                          classNamePrefix=""
                        />
                        <AvField
                          name="rank_id"
                          type="hidden"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="rank_id"
                          value={this.state.rankSelected}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Pengambilan Sumpah{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <input
                          name="Sumpah"
                          type="checkbox"
                          checked={this.state.isChecked}
                          onChange={this.onChangeSumpah}
                        />
                        <AvField
                          name="sumpah_selected"
                          type="hidden"
                          id="sumpah_selected"
                          value={this.state.dataForm.sumpahSelected}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        File Dokumen <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <FileInput name="document" />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Dokumen Terupload</label>
                      <Col md="9">
                        {this.state.document ? (
                          <>
                            {this.state.document !== "" ? (
                              <a
                                target="_blank"
                                rel="noreferrer"
                                class="btn btn-sm btn-primary"
                                href={this.state.document.documents_path}
                              >
                                <i className="uil-file-download"></i> Download
                                File
                              </a>
                            ) : (
                              "Tidak ada dokumen"
                            )}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/kepegawaian/home.html?skp3k">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/home.html?skp3k" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
